// extracted by mini-css-extract-plugin
export default {"button":"css_button__gZhqG","black":"css_black__UXAoz"};